





import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class BadgeNotify extends Vue {
  @Prop({ default: null }) projectId!: number | null;

  get existsNotTaggedUnreadMessage(): boolean {
    if (this.projectMessage) {
      return this.projectMessage.hasUntaggedUnreadMessages;
    }

    return this.$store.getters.existsNotTaggedUnreadMessage;
  }

  get totalUnreadMessage(): number {
    if (this.projectMessage !== null && this.projectMessage !== undefined) {
      return this.projectMessage.count;
    }

    return this.$store.getters.totalUnreadMessage;
  }

  get projectMessage() {
    if (this.projectId && this.listProjectMessage) {
      return this.listProjectMessage[+this.projectId];
    }
    return null;
  }

  get listProjectMessage() {
    return this.$store.state.message.unreadMessages;
  }

  get showIcon(): boolean {
    if (this.projectId) {
      return this.existsNotTaggedUnreadMessage || this.totalUnreadMessage > 0;
    }

    return this.totalUnreadMessage > 0;
  }

  get displayUnreadCount() {
    return this.totalUnreadMessage || "";
  }
}
